import React, { Component } from 'react'
import styles from './styles.module.scss'
import cx from 'classnames'
import GridLayout from "src/legacy/components/GridLayout";

import _ from 'lodash';
import { Link } from "react-router-dom";
import dateFormat from 'dateformat';
import { connect } from 'react-redux';
import InfiniteScroll from "react-infinite-scroller";
import { localizedStrings } from 'src/localization/index.jsx';

import { fetchDealTimeline, fetchDealSharedAssets, fetchDealSharedCollections } from "src/legacy/redux/actions/dealInsights";
import AssetIcon from 'src/components/asset/icon';
import Text from 'src/components/text';

const AssetDefaultIcon ='/images/defaultIcons/default_asset.jpg'
const EmptyContent = '/images/noActivity.svg'
const EmptyResult = '/images/assets/assetsEmptyMessage.svg'

class TimeLineViewComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSharedContent: false,
      showTimeLine: true,
      showMoreAssets: false,
      showMoreCollections: false,
      istimeLineExists: false
    }

    this.handleSharedContentClick = this.handleSharedContentClick.bind(this);
    this.renderTimeLine = this.renderTimeLine.bind(this);
    this.renderSharedContent = this.renderSharedContent.bind(this);
    this._renderChildren = this._renderChildren.bind(this);
    this.renderAssets = this.renderAssets.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.renderCollections = this.renderCollections.bind(this);
    this._renderCollectionList = this._renderCollectionList.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);

    this.localizedDealinsights = localizedStrings.pages.dealInsights;
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.isNoContentShared = this.isNoContentShared.bind(this);
  }

  componentDidMount() {
    if (_.get(this.props, "params.id")) {
      this.props.fetchDealTimeline(_.get(this.props, "params.id"), { page: 0, limit: 20 });
      this.props.fetchDealSharedAssets(_.get(this.props, "params.id"));
      this.props.fetchDealSharedCollections(_.get(this.props, "params.id"));
    }
  }

  componentWillReceiveProps(nextProps) {

    if (_.size(nextProps.timeline) > 0) {

      this.setState({
        istimeLineExists: true
      })
    }
    else {

      this.setState({
        istimeLineExists: false
      })
    }

  }

  handleSharedContentClick(type) {
    this.setState({
      showTimeLine: type === "timeline",
      showSharedContent: type === "contentShared"
    })
  }

  loadMoreTimeline() {

    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.isTimelineFetching || nextPage >= totalPages) {
      return;
    }

    this.props.fetchDealTimeline(_.get(this.props, "params.id"), { page: nextPage, limit: 20 });
  }


  renderTimeLine() {

    if (this.props.isTimelineFetching) {
      return <p className={styles.emptyMessageContainer}> {`${this.localizedCommons.loading.loading}...`}</p>
    }

    if (!this.state.istimeLineExists) {
      return <div className={styles.emptyMessageContainer}>
        <div>
          <img src={EmptyContent} />
          <p>{`${this.localizedDealinsights.deal_details.content_shared.no_activity}!`}</p>
        </div>
      </div>
    }

    return <div>

      <div className={styles.timeLineContainer}>
        <div className={styles.dataContainer} >
          {this.state.istimeLineExists && <div className={styles.eventBodyContainer}>
            <InfiniteScroll
              pageStart={0}
              initialLoad={false}
              hasMore={this.props.currentPage < this.props.totalPages}
              loadMore={() => {
                this.loadMoreTimeline();
              }}
              useWindow={false}
              threshold={200}
            >
              {this.props.timeline.filter((event) => !_.isEmpty(event.type)).map((event, index) => (
                <div key={index} className={styles.eventContent}>

                  <span className={cx(styles.dot, {
                    [styles.disableLine]: index + 1 === _.size(this.props.timeline)
                  })} />

                  <div className={styles.eventBody}>
                    {event.type && <div>
                      {this.getDescription(event)}
                      <p className={styles.subtext}>
                        {dateFormat(event.createdDate, 'dd mmm yyyy')}
                      </p>

                    </div>}
                  </div>

                </div>
              ))}
            </InfiniteScroll>
          </div>
          }
        </div>
      </div>

    </div>
  }

  _renderChildren() {
    var children = Array();
    _.get(this.props, "sharedAssets.items", []).forEach((asset) => {
      children.push(
        <Link to={`/assets/${asset.id}`} target="_blank" className={styles.link}>
          <div className={styles.assetCard}>
            <AssetIcon key={asset.id} asset={asset} />
           <Text className={styles.assetName} text={asset.name} lines={1} />
          </div>
        </Link>
      )
    });

    return children;
  }

  handleShowMore(type) {
    if (type === "asset") {
      this.setState(prevState => ({
        showMoreAssets: !prevState.showMoreAssets
      }))
    }
    else {
      this.setState(prevState => ({
        showMoreCollections: !prevState.showMoreCollections
      }))
    }

  }

  handleLoadMore() {
    const currentPage = _.get(this.props, "sharedAssets.currentPage", 0);
    const totalPages = _.get(this.props, "sharedAssets.totalPages", 0);
    const fetching = _.get(this.props, "sharedAssets.fetching", true);
    const nextPage = currentPage + 1;

    if (fetching || nextPage >= totalPages) {
      return;
    }

    this.props.fetchDealSharedAssets(_.get(this.props, "deal.id"), nextPage);
  }


  renderAssets() {

    return (
      <div className={styles.assetContainer}>
        <p className={styles.assetTitle}>{this.localizedKeywords.assets} - {_.get(this.props, "sharedAssets.totalRecordsCount", 0)}</p>
        <div className={cx(styles.assetsListContainer, {
          [styles.maxHeight]: this.state.showMoreAssets
        })}>
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            hasMore={true}
            loadMore={this.handleLoadMore}
            useWindow={false}
            threshold={200}
          >
            <GridLayout className={styles.layout} itemClass={styles.collection}>
              {this._renderChildren()}
            </GridLayout>
          </InfiniteScroll>

        </div>
        {_.size(_.get(this.props, "sharedAssets.items")) > 0 && _.get(this.props, "sharedAssets.fetching", false) && <p className={styles.loading}>{this.localizedCommons.loading.loading}...</p>}
      </div>
    )
  }

  _renderCollectionList() {
    return (
      <div>
        <div className={cx(styles.collectionListContainer)}>
          {this.props.collections.map((folio, index) => (
            <Link key={folio.id} to={`/collections/${folio.id}`} target="_blank" className={styles.folioContainer}>
              <div >
                <img src={_.get(folio, "icon.thumbnail", AssetDefaultIcon)} />
                <p><Text text={folio.name} /></p>

              </div>
            </Link>
          ))}

        </div>
      </div>
    )
  }

  renderCollections() {
    const collectionsCount = _.size(this.props.collections);
    return (
      <div className={styles.silderCollectionContent}>
        <p className={styles.collectionTitle}>{collectionsCount > 1 ? this.localizedKeywords.collections : this.localizedKeywords.collection} - {collectionsCount}</p>
        <div className={styles.collectionContainer}>
          {this._renderCollectionList()}

        </div>
      </div>
    )

  }

  renderSharedContent() {

    if ((this.props.isSharedAssetsFetching && _.size(_.get(this.props, "sharedAssets.items")) === 0) || this.props.isSharedCollectionsFetching) {
      return <p className={styles.emptyMessageContainer}> {`${this.localizedCommons.loading.loading}...`} </p>
    }

    if (this.isNoContentShared()) {
      return <div className={styles.emptyMessageContainer}>
        <div>
          <img src={EmptyResult} />
          <p> No content shared!</p>
        </div>
      </div>
    }

    return (
      <div className={styles.contentSharedContainer}>
        {_.size(_.get(this.props, "sharedAssets.items")) > 0 && this.renderAssets()}
        {_.size(_.get(this.props, "collections")) > 0 && this.renderCollections()}

      </div>
    )
  }

  getDescription(event) {

    let firstName = _.get(event, "contact.firstName") || _.get(event, "visitor.firstName") || _.get(event, "user.firstName");
    let targetName = _.get(event, "target.name", "");
    let stageName = _.get(event, "stage", "");
    let assetAdded = _.get(event, "assetAdded.name", "");

    switch (event.type) {
      case "link_clicked":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.link_clicked} </p>
      case "email_open":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.email_open} </p>
      case "asset_added":
        return <p>{firstName} {this.localizedDealinsights.deal_details.timeline.asset_added} {_.size(assetAdded) > 0 && <span className={styles.name}> "{assetAdded}" </span>}</p>
      case "asset_download":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.downloaded} {_.size(targetName) > 0 && <span className={styles.name}>    "{targetName}" </span>}</p>
      case "asset_viewed":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.view_asset} {_.size(targetName) > 0 && <span className={styles.name}>   "{targetName}" </span>}</p>
      case "assets_reshared":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.reshare_asset}  {_.size(targetName) > 0 && <span className={styles.name}>    "{targetName}" </span>}</p>
      case "collection_reshared":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.reshare_collection} {_.size(targetName) > 0 && <span className={styles.name}>    "{targetName}" </span>}</p>
      case "collection_viewed":
        return <p> {firstName} {this.localizedDealinsights.deal_details.timeline.view_collection} {_.size(targetName) > 0 && <span className={styles.name}>    "{targetName}" </span>}</p>
      case "lead_captured":
        return <p> {this.localizedDealinsights.deal_details.timeline.lead_capture} {_.size(firstName) > 0 && <span className={styles.name}>   : "{firstName}" </span>}</p>
      case "opportunity_stage_change":
        return <p> {this.localizedDealinsights.deal_details.timeline.deal_update} {_.size(stageName) > 0 && <span className={styles.name}>    "{stageName}" </span>} </p>
    }
  }

  isNoContentShared() {
    return _.size(_.get(this.props, "sharedAssets.items")) === 0 && _.size(this.props.collections) === 0;
  }

  render() {
    return (
      <div className={styles.sliderContainer}>
        <div className={styles.timeLine}>
          <div className={styles.timeLineHeaderContainer}>
            <button className={cx(styles.timeLineTitle, {
              [styles.active]: this.state.showTimeLine
            })} onClick={() => this.handleSharedContentClick("timeline")}> {this.localizedDealinsights.deal_details.timeline.title}</button>
            <button className={cx(styles.contentTitle, {
              [styles.active]: this.state.showSharedContent
            })} onClick={() => this.handleSharedContentClick("contentShared")}> {this.localizedDealinsights.deal_details.content_shared.share} </button>
          </div>
          <div className={styles.sliderContentContainer}>
            {this.state.showTimeLine && this.renderTimeLine()}
            {this.state.showSharedContent && this.renderSharedContent()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    timeline: _.get(state, "legacyRootReducer.dealInsights.timeline.items", []),
    isTimelineFetching: _.get(state, "legacyRootReducer.dealInsights.timeline.fetching", false),
    currentPage: _.get(state, "legacyRootReducer.dealInsights.timeline.currentPage", 0),
    totalPages: _.get(state, "legacyRootReducer.dealInsights.timeline.totalPages", 1),
    totalRecordsCount: _.get(state, "legacyRootReducer.dealInsights.timeline.totalRecordsCount", 0),
    sharedAssets: _.get(state, "legacyRootReducer.dealInsights.sharedAssets", []),
    collections: _.get(state, "legacyRootReducer.dealInsights.sharedCollections.items", []),
    isSharedAssetsFetching: _.get(state, "legacyRootReducer.dealInsights.sharedAssets.fetching", false),
    isSharedCollectionsFetching: _.get(state, "legacyRootReducer.dealInsights.sharedCollections.fetching", false),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDealTimeline: (id, params) => {
      return dispatch(fetchDealTimeline(id, params));
    },
    fetchDealSharedAssets: (id, page) => {
      return dispatch(fetchDealSharedAssets(id, page));
    },
    fetchDealSharedCollections: (id) => {
      return dispatch(fetchDealSharedCollections(id));
    }
  }
}
const TimeLineView = connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeLineViewComponent);

export default TimeLineView;
